import type { IncentiveOfferState } from '@/store';
import { appStore } from '@/store';

const updateCheckoutIncentive = (flag: boolean): void => {
  const { form: formActions } = appStore.getActions();
  formActions.updateIsSignupIncentiveOptIn(flag);
};

const updateIncentiveOfferState = (
  incentiveOfferState: IncentiveOfferState,
  offerEligible: boolean,
  onboardOption: string,
  countToggles: number,
): void => {
  const { ui: uiActions } = appStore.getActions();
  uiActions.setIncentiveOfferState({
    ...incentiveOfferState,
    shouldDisplayOffer: offerEligible && onboardOption === 'guest',
    shouldDisplayOfferAccepted:
      offerEligible && countToggles > 1 && onboardOption === 'signup',
  });
};

export { updateCheckoutIncentive, updateIncentiveOfferState };
